<template>
    <div class="of-content4-topper">
        <img class="img-left" :src="topper.imgLeftPath" alt="" srcset="">
        <img class="img-right" :src="topper.imgRightPath" alt="" srcset="">
        <div class="topper-content">
            <h1 class="title" v-html="topper.title1" ></h1>
            <h1 class="title" v-html="topper.title2" ></h1>
            <h4 class="text"  v-html="topper.text" ></h4>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'topper',
        props: ['view'],
        data() {
            return {
                title1: '40+',
                title2: 'Tools',
                text: 'We Provide Every Other Tool You Will Ever Need To Explode Your Business Online!',
                imgLeftPath: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-left.svg',
                imgRightPath: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-right.svg'
            }
        },
        computed: {
            topper: function () {
                return (this.view !== undefined && this.view !== null) ? this.view : this.$data
            }
        },
        created(){

        },
        mounted(){

        }
    }
</script>

<style scoped lang="scss">
    @import "../../../../../scss/office";
    
    .of-content4-topper {
        font: inherit;
        position: relative;
        
        height: 61.3em; /* 613px */

        .img-left{
            font: inherit;
            position: absolute;
            top: 0;
            left: 0;
            width: auto;
            height: 100%;
            z-index: 0;
        }

        .img-right{
            font: inherit;
            position: absolute;
            top: 5.7096248%; /* 35px */
            left: calc(0.752039152*61.3em); /*461px*/
            width: auto;
            height: 79.6084829%; /*488px*/
            z-index: 1;
        }

        .topper-content{
            font: inherit;
            position: relative;
            z-index: 2;
            

            max-width: calc(0.752039152*61.3em); /*461px*/
            padding: 10em 2.4em 10em 8em; /* 100px 32px 100px 80px */
            height: 100%;
            
            h1,
            .title{
                font: inherit;
                text-align: left;

                margin: 0;
                padding: 0;

                background-color: transparent;
                color: $of-color3;

                font-size: 7em; /*70px*/
                font-family: "Mulish";
                font-weight: 700;
                line-height: 1.2;

            }

            h1:first-child,
            .title:first-child{
                margin-left: 0.142857143em; /*10px*/
            }

            h4,
            .text{
                font: inherit;
                text-align: left;

                margin: 0;
                padding: 0;

                background-color: transparent;
                color: $of-color3;

                font-size: 2em; /*20px*/
                font-weight: 900;
                line-height: 1.2;

                margin-top: 1.55em; /* 31px */

            }
        }
    }

    @media (max-width: 1024px) { /* smartphones */
        .of-content4-topper {
            font: inherit;

            .img-left,
            .img-right{
                display:  none;
            }
            
            .topper-content{
                font: inherit;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;

                background-color: $of-color1;
                color: $of-color3;

                
                max-width: 100%;
                width: 100%;
                height: auto;

                padding: 10em 2em; /*100px 20px*/

                h1:first-child,
                .title:first-child{
                    margin-left: 0;
                }
                h1,
                .title,
                h4,
                .text{
                    text-align: center;
                }


                h1,
                .title{
                    font-size: 7.5em; /* 75px */
                    word-break: break-word;
                }

                h4,
                .text{
                    max-width: 50%;
                    font-size: 2.1428571429; /* 21.428571429px */
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/office/js/components/dashboard/onboardingFunnel/content-4/topper.vue